import { Mark, mergeAttributes } from '@tiptap/core';

export const HIGHLIGHT_MARK_NAME = 'highlight';

/**
 * Word's highlighter, shown as itself.
 *
 * The reason it is worth carrying at all: an analyst preparing a `.docx` marks every blank they
 * have to come back to with the highlighter, so the yellow IS the list of placeholders still to
 * replace with a field. Dropped at import, the editor showed `[●]` as ordinary prose and there
 * was nothing to distinguish it from the letter's own text.
 *
 * The renderer deliberately does not draw it — see `markStyle` in `flowRender`. A deed with
 * highlighter across it is not fit to execute.
 */
export const HighlightMark = Mark.create({
	name: HIGHLIGHT_MARK_NAME,

	addAttributes() {
		return {
			color: {
				default: '#ffff00',
				parseHTML: (element) =>
					element.getAttribute('data-color') ?? element.style.backgroundColor,
				renderHTML: (attributes) => ({
					'data-color': attributes.color,
					// A custom property rather than the shorthand, so the stylesheet keeps
					// control of how a highlight reads next to a field chip.
					style: `--ds-highlight: ${String(attributes.color)}`,
				}),
			},
		};
	},

	parseHTML() {
		return [{ tag: 'mark' }];
	},

	renderHTML({ HTMLAttributes }) {
		return ['mark', mergeAttributes(HTMLAttributes), 0];
	},
});
